/**
 * Capitalize first character only, leave rest untouched.
 * Preserves "McDonald", "O'Brien" etc.
 * All-caps input is lowercased first ("ANNA" -> "Anna").
 */
export const capitalizeFirst = (value) => {
  if (!value || typeof value !== 'string') return value;
  const v = value === value.toUpperCase() ? value.toLowerCase() : value;
  return v.charAt(0).toUpperCase() + v.slice(1);
};

/**
 * Capitalize after start, space, or hyphen.
 * Also capitalizes after single-letter name prefixes with apostrophe (O'Brien, D'Arcy).
 * Does not capitalize possessive 's (Brien's stays Brien's).
 * All-caps input is lowercased first ("SOME NAME" -> "Some Name").
 */
export const capitalizeWords = (value) => {
  if (!value || typeof value !== 'string') return value;
  const v = value === value.toUpperCase() ? value.toLowerCase() : value;
  return v
    .replace(/(^|[\s-])\S/g, (match) => match.toUpperCase())
    .replace(/\b(\w)'(\w)/g, (match, before, after) => `${before}'${after.toUpperCase()}`);
};

/**
 * Combine first + last name, trimming and null-safe.
 */
export const combineName = (first, last) =>
  `${String(first ?? '').trim()} ${String(last ?? '').trim()}`.trim();

/**
 * Lowercase entire string. Used for emails/usernames.
 */
export const toLower = (value) => {
  if (!value || typeof value !== 'string') return value;
  return value.toLowerCase();
};
